export const mapNullKeysToEmptyString = <T extends { [key: string]: unknown }>(obj: T) =>
  Object.entries(obj).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value === null ? '' : value }),
    {} as T,
  )
